<template>
  <div class="leavePage" v-if="!showLoad">
    <van-cell-group class="baseNone baseSalary">
      <van-field
        v-model="baseData.realName"
        v-if="mode != 'add'"
        readonly
        label="申请人："
        class="ggInput"
      />
      <van-cell
        title="申请人："
        v-else
        readonly
        v-model="userinfo.realName"
        class="ggInput"
      />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary">
      <van-cell
        v-if="mode == 'add'"
        title="入职日期："
        v-model="userinfo.employedDate"
        class="ggInput"
      />
      <van-field
        v-model="baseData.employedDate"
        v-else
        readonly
        label="入职日期："
        class="ggInput"
      />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary moreText">
      <van-field
        label="最后工作日："
        :required="editType"
        readonly
        v-model="baseData.expectedTime"
        @click="TimePicker"
        :is-link="editType"
        :placeholder="editType ? '请选择' : ''"
        class="ggInput"
      />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary">
      <van-field
        label="离职类型："
        :required="editType"
        readonly
        v-model="baseData.resignTypeName"
        class="ggInput"
        @click="
          editType == true
            ? (showLeavePicker = true)
            : (showLeavePicker = false)
        "
        :is-link="editType"
        :placeholder="editType ? '请选择' : ''"
      />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary beizhu">
      <van-field
        v-model="baseData.reason"
        rows="1"
        autosize
        :required="editType"
        label="离职原因："
        type="textarea"
        :placeholder="editType ? '请输入...  ' : ''"
        :readonly="!editType"
      />
    </van-cell-group>
    <!-- 附件 -->
    <!-- 微信的附件 避免和原生交互 -->
    <wx-file-view
      v-if="is_weixn"
      :filesData="baseData"
      class="fileview"
    ></wx-file-view>
    <!-- 原生附件 -->
    <file-view
      v-if="!is_weixn"
      :filesData="baseData"
      :editType="editType"
      @changeFile="changebaseAnnexes"
      class="fileview"
    ></file-view>

    <!-- 审批流程 -->
    <div
      class="approveList"
      v-if="mode !== 'add' && baseData.verifyStatus != 'hold'"
    >
      <audit-list :applicantData="baseData"></audit-list>
    </div>
    <!-- 流程图 -->
    <div
      class="flowList"
      v-if="mode !== 'add' && baseData.verifyStatus != 'hold'"
    >
      <flow-staff :applicantData="baseData"></flow-staff>
      <flow-list :workflowCode="baseData.workflowCode"></flow-list>
    </div>
    <!-- 审批 -->
    <van-popup
      v-model="verifyPageType"
      closeable
      round
      close-icon="close"
      position="bottom"
      class="verifyPage"
    >
      <verify-main
        :applicantData="baseData"
        @changeVerifyType="setVerifyType"
      ></verify-main>
    </van-popup>
    <!-- 操作按钮 -->
    <!-- 新增状态下提交 -->
    <div class="btnBox" v-if="mode == 'add'">
      <van-button
        type="info"
        :loading="btnLoading"
        :loading-text="loadingText"
        @click="checkInput('add')"
        >提交</van-button
      >
    </div>
    <!-- 编辑状态下 -->
    <template v-else-if="editType && mode != 'verify'">
      <div
        class="btnBox editBtnbox clearfix"
        v-if="baseData.verifyStatus == 'hold'"
      >
        <van-row class="dis_flex justy_space btnGroup">
          <van-col span="10">
            <van-button
              type="danger"
              :loading="btnLoading"
              :loading-text="loadingText"
              @click="delApply('del')"
              >删除</van-button
            >
          </van-col>
          <van-col span="4"></van-col>
          <van-col span="10">
            <van-button
              type="info"
              :loading="btnLoading"
              :loading-text="loadingText"
              @click="checkInput('edit')"
              >保存</van-button
            >
          </van-col>
        </van-row>
      </div>
      <div
        class="btnBox denyBtn clearfix"
        v-if="baseData.verifyStatus == 'deny' && mode != 'verify'"
      >
        <van-button
          type="info"
          :loading="btnLoading"
          :loading-text="loadingText"
          @click="checkInput('edit')"
          >再次提交</van-button
        >
      </div>
    </template>
    <div
      class="btnBox denyBtn clearfix"
      v-if="
        baseData.verifyStatus == 'pending' &&
        mode != 'verify' &&
        sendType != '1'
      "
    >
      <van-button
        type="info"
        :loading="btnLoading"
        :loading-text="loadingText"
        @click="delApply('ch')"
        >撤回修改</van-button
      >
    </div>
    <!-- 审批按钮 -->
    <div
      class="btnBox denyBtn clearfix"
      v-if="
        (mode == 'verify' &&
          baseData.verifyStatus == 'pending' &&
          verifyType == '1') ||
        (mode == 'verify' &&
          baseData.verifyStatus == 'doing' &&
          verifyType == '1')
      "
    >
      <van-button type="info" @click="verifyPage">{{
        verifyPageText
      }}</van-button>
    </div>
    <!-- 弹出层 -->
    <!-- 时间选择器 -->
    <van-popup v-model="showTimePicker" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        @cancel="closeTimePicker"
        @confirm="onTimeConfirm"
        :min-date="minDate"
      />
    </van-popup>
    <!-- 离职类型列表 -->
    <van-popup v-model="showLeavePicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="this.leaveTypeList"
        value-key="dictName"
        @cancel="showLeavePicker = false"
        @confirm="saveLeaveType"
      />
    </van-popup>

    <refresh-page v-if="refreshPage" />
  </div>
</template>
<script>
/* eslint-disable */
import { mapState, mapMutations } from "vuex";
const refreshPage = () => import("@/components/common/refreshPage");
const fileView = () => import("@/components/common/fileView");
const wxFileView = () => import("@/components/common/wxFileView");
const flowList = () => import("@/components/common/flowList");
const auditList = () => import("@/components/common/auditList");
const verifyMain = () => import("@/components/common/verifyMain");
const flowStaff = () => import("@/components/common/flowStaff");
import { dateFormat, getDictList, getURLParam } from "@/utils/common";

import {
  getDeviceType,
  closePage,
  is_wei,
} from "@/common/getDeviceType/getDeviceType";

export default {
  name: "leaveOffice",
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      mode: "add",
      commonId: "", //编辑Id
      editType: false, //当前表单是否可以编辑
      baseData: {
        resignTypeName: "",
        resignType: "", //离职类型
        reason: "", //离职原因
        expectedTime: "", //预计离职时间
        verifyStatus: "hold",
        baseAnnexes: [], //附件
      },

      verifyPageType: false, //审批弹框,默认不显示
      verifyPageText: "",
      verifyType: "", //判断是否已审核
      btnLoading: false, //btn是否为加载状态
      loadingText: "操作中...", //	btn加载状态提示文字
      leaveCode: "lizhi",

      showLeavePicker: false, //离职类型弹框
      leaveTypeList: [], //离职类型列表

      showTimePicker: false, //时间控件

      currentDate: new Date(), //当前时间
      minDate: new Date(2020, 1, 1),

      refreshPage: false, // 网络请求失败时显示
      sendType: "", //判断是否在抄送列表
      clientType: getDeviceType(), //手机类型
      is_weixn: is_wei(), //是否为微信
    };
  },

  components: {
    refreshPage,
    fileView,
    wxFileView,
    auditList,
    flowList,
    verifyMain,
    flowStaff,
  },
  async mounted() {
    document.title = "离职申请";
    window.editPage = this.editPage; //编辑页面
    this.leaveTypeList = await getDictList(this.leaveCode);
    this.verifyType = this.$route.query.verifyType; //审核状态是否已审核
    this.commonId = this.$route.query.commonId; //申请Id
    this.mode = this.$route.query.commonType; // add:新增 edit:查看/编辑 verify 审批
    this.sendType = this.$route.query.sendType; // 1：在抄送列表
    this.editType = this.mode == "add" ? true : false;
    this.$nextTick(() => {
      this.setShowLoad(false); //加载状态，默认为true加载
      if (this.userinfo && this.userinfo.id) {
        this.verifyPageText = this.verifyType == "1" ? "审批" : "查看";

        this.mode != "add" ? this.initPage() : "";
      }
    });
  },
  methods: {
    ...mapMutations(["setShowLoad"]),
    editPage() {
      //app调用编辑
      this.editType = true;
    },
    verifyPage() {
      //app调用审批
      this.verifyPageType = true;
    },

    initPage() {
      let _this = this;

      _this.$api.userCenter.user.leavePosition
        .leaveDetail(this.commonId)
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            _this.baseData = res.data;
            if (
              (_this.baseData.verifyStatus == "hold" ||
                _this.baseData.verifyStatus == "deny") &&
              _this.mode == "edit"
            ) {
              if (_this.clientType == "android") {
                window.android.getInfo(102);
              } else {
                window.webkit.messageHandlers.showEdit.postMessage(null);
              }
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    saveLeaveType(data) {
      //选择离职类型列表
      this.showLeavePicker = false;
      this.baseData.resignType = data.dictCode;
      this.baseData.resignTypeName = data.dictName;
    },
    //监测附件方法
    changebaseAnnexes(data) {
      this.baseData.baseAnnexes = data;
    },
    //微信状态下 监测已审核  修改状态
    setVerifyType(data) {
      this.verifyPageType = false;
      if (data) {
        this.verifyType = "2";
      }
    },
    checkInput() {
      let _this = this;
      if (
        _this.baseData.expectedTime == "" ||
        this.baseData.resignType == "" ||
        this.baseData.reason == ""
      ) {
        _this.$toast("带星号为必填，不能为空");
      } else {
        _this.saveLeave();
      }
    },
    saveLeave() {
      //提交离职申请
      let _this = this;
      _this.btnLoading = true;
      _this.$api.userCenter.user.leavePosition
        .addLeaveApply(_this.mode, _this.baseData)
        .then((res) => {
          if (res.code == "1") {
            let text = this.mode == "add" ? "添加成功" : "编辑成功";
            closePage(text);
          } else {
            // console.log(res.msg);
            _this.$toast(res.msg);
          }
          _this.btnLoading = false;
        })
        .catch((err) => {
          console.log(err);
          _this.btnLoading = false;
          _this.$toast("网络失败，请稍后重试");
        });
    },
    delApply(type) {
      let _this = this;
      _this.btnLoading = true;
      _this.$api.userCenter.user.leavePosition
        .delApply(type, _this.baseData.id)
        .then((res) => {
          if (res.code == "1") {
            let text = type == "ch" ? "撤回操作成功" : "删除操作成功";
            closePage(text);
          } else {
            // console.log(res.msg);
            _this.$toast(res.msg);
          }
          _this.btnLoading = false;
        })
        .catch((err) => {
          console.log(err);
          _this.btnLoading = false;
          _this.$toast("网络失败，请稍后重试");
        });
    },
    TimePicker() {
      let _this = this;
      if (_this.editType) {
        _this.showTimePicker = true;
      }
    },
    onTimeConfirm(data) {
      //选择时间回调
      this.showTimePicker = false;
      this.baseData.expectedTime = dateFormat(data);
    },
    closeTimePicker() {
      this.showTimePicker = false;
    },
    myformate(time) {
      //格式化时间
      let str = time + "";
      let index = str.indexOf("GMT");
      return index > 0 ? dateFormat(time) : time.substring(0, 10);
    },
  },
  computed: {
    ...mapState(["showLoad", "userinfo"]),
  },
  watch: {
    userinfo: {
      handler: function (val) {
        if (val && val.id && this.mode != "add") {
          this.initPage();
        }
      },
      deep: true,
    },
  },
};
</script>
<style lang="less">
.leavePage {
  width: 100%;
  // height: 100%;
  background-color: #f6f6f6;
  padding-top: 12px;

  .baseNone {
    .van-field__body {
      .van-field__control {
        text-align: right;
        color: #969799;
      }
    }
  }
  .baseNone.beizhu {
    min-height: 45px;
  }
  .btnBox {
    width: 100%;
    padding: 0 14px;
    height: 65px;
    position: fixed;
    left: 0;
    bottom: 0;
    padding-top: 10px;
    z-index: 1009;
    background-color: #fff;
    button {
      width: 100%;
      border-radius: 12px;
      -webkit-border-radius: 12px;
      -moz-border-radius: 12px;
      span {
        line-height: 45px;
      }
    }
  }
  //审批记录样式
  .approveList {
    margin-top: 10px;
  }
  //流程图样式
  .flowList {
    margin-top: 10px;
  }
}
</style>